import React, { useState } from 'react'
import * as Content from '../Content'
import * as Form from '../Form'
import * as Input from '../Input'
import { View } from './View'

export interface IDialogProps {
  title: string
  message: string
  onDismiss: () => void
  onConfirm?: (message?: string | null) => void
  allowMessage?: boolean
  messageLabel?: string
  cancelLabel?: string
  confirmLabel?: string
  destructive?: boolean
  loading?: boolean
}

const FLEX_COLUMN = 'flex flex-col'
const CONTAINER_STYLES = `${FLEX_COLUMN} p-8 pt-0`
const LABEL_CONTAINER_STYLES = `${FLEX_COLUMN} w-full mb-2`

export const Dialog: React.FunctionComponent<IDialogProps> = (props) => {
  const [message, setMessage] = useState(null as string | null)
  const handleConfirm = () =>
    props.onConfirm ? props.onConfirm(message) : null
  const handleChange: React.ChangeEventHandler = (e) => {
    setMessage((e.target as HTMLTextAreaElement).value)
  }

  const handleButtonClick = (
    callback: () => void
  ): React.MouseEventHandler<HTMLButtonElement> => (e) => {
    e.stopPropagation()
    callback()
  }

  return (
    <View onDismiss={props.onDismiss} loading={props.loading}>
      <div className={CONTAINER_STYLES}>
        <Content.HeadingSmall>{props.title}</Content.HeadingSmall>
        <Content.Body>{props.message}</Content.Body>
        {props.allowMessage ? (
          <div className={LABEL_CONTAINER_STYLES}>
            <Form.Label>
              {props.messageLabel ?? 'Add an optional message:'}
            </Form.Label>
            <Input.TextArea value={message ?? ''} onChange={handleChange} />
          </div>
        ) : null}
        <Form.ButtonGroup direction="row">
          <Form.Button onClick={handleButtonClick(props.onDismiss)}>
            <span>{props.cancelLabel ?? 'Cancel'}</span>
          </Form.Button>
          {props.onConfirm ? (
            <Form.Button
              onClick={handleButtonClick(handleConfirm)}
              appearance={props.destructive ? 'destructive' : 'actionable'}
            >
              <span>{props.confirmLabel ?? 'Confirm'}</span>
            </Form.Button>
          ) : null}
        </Form.ButtonGroup>
      </div>
    </View>
  )
}
